import { autoDarkColors } from "@/modules/theme/color/darkModeColor.ts";
import type { ThemeProps, ThemeVarGetters, ThemeVariant } from "@/modules/theme/types.ts";

import png from "@/styles/cognovum/apple-touch-icon.png?url";
import icon from "@/styles/cognovum/favicon.ico?url";
import favicon from "@/styles/cognovum/favicon.svg?url";
import loginIntroBg from "@/styles/cognovum/login-bg.svg?url";
import logoDark from "@/styles/cognovum/logo-dark.svg?url";
import loginLogo from "@/styles/cognovum/logo.svg";
import logo from "@/styles/cognovum/logo.svg?url";

export function makeTheme(variant: ThemeVariant) {
    const { isDark } = variant;

    const baseColors: ThemeVarGetters = autoDarkColors({
        "color-primary": "#1e70ea",
        "color-secondary": "#e5e5e5",
    });

    return {
        ...baseColors,

        "logo-image": isDark ? `url("${logoDark}")` : `url("${logo}")`,

        "header-logo-width": "96px",
        "header-logo-height": "18px",

        "sidenav-item-text-color": isDark ? "#FFFFFF" : "var(--color-text)",
        "sidenav-item-before-display": "none",
        "sidenav-item-hover-bg-color": "var(--color-primary)",
        "sidenav-item-hover-icon-color": "#FFFFFF",
        "sidenav-item-hover-text-color": "#FFFFFF",
        "sidenav-item-active-bg-color": "var(--color-primary)",
        "sidenav-item-active-icon-color": "#FFFFFF",
        "sidenav-item-active-text-color": "#FFFFFF",
        "sidenav-item-active-before-display": "none",

        //#region Login
        "login-body-bg-color": "#f2f2f2",
        "login-body-bg-size": "cover",
        "login-body-text-color": "#808080",
        "login-justify-content": "space-between",
        "login-align-items": "stretch",

        "login-intro-display": "flex",
        "login-intro-bg-image": `url("${loginIntroBg}")`,
        "login-intro-bg-size": "36%",
        "login-intro-bg-position": "50% calc(50% - 60px)",
        "login-intro-text-align": "left",
        "login-intro-flex-direction": "row",
        "login-intro-justify-content": "center",
        "login-intro-align-items": "flex-end",
        "login-intro-padding": "60px",
        "login-title-font-size": "24px",
        "login-title-text-color": "var(--color-primary)",
        "login-title-font-weight": 600,
        "login-title-line-height": 1,
        "login-title-max-width": "300px",
        "login-title-padding": "0",
        "login-subtitle-font-size": "16px",
        "login-subtitle-max-width": "400px",

        "login-form-title-font-size": "20px",
        "login-form-bg-color": "var(--color-white)",
        "login-form-text-color": "var(--color-text)",
        "login-form-input-border-color": "#dbe2e9",
        "login-form-button-border-radius": "var(--input-border-radius)",
        "login-form-or-text-color": "#dbe2e9",
        "login-form-or-border-color": "#dbe2e9",
        "login-form-google-bg-color": "#007bf5",
        "login-form-more-text-color": "var(--color-primary)",
        "login-form-more-bg-color": "var(--color-white)",
        "login-form-more-border-color": "var(--color-primary)",
        //#endregion
    } satisfies ThemeVarGetters;
}

export const props: ThemeProps = {
    favicon,
    icon,
    png,
    loginLogoImg: {
        src: loginLogo,
        style: {
            maxWidth: "200px",
        },
    },
};
